import React, { Component } from 'react';
import { LOGIN_ROUTE_AFFILIATE, LOGIN_ROUTE_CLIENT } from '../configs/staticConfigs'; 
import { LBL_APP_NAME, LBL_LOGIN_AFFILIATE, LBL_LOGIN_CLIENT, LBL_IOS_APP_FOR_STAFF, LBL_ANDROID_APP_FOR_STAFF } from '../configs/labelConfigs';
import { URL_IMG, LOGO_URL } from '../configs/urlConfigs'; 
import FooterComponent from './commons/layouts/footerComponent';

class LoginView extends Component {
    
    componentDidMount() {
        document.title = LBL_APP_NAME+' : Home';
        document.body.classList.add('home');
    }

    componentWillUnmount() {
        document.body.classList.remove('home'); 
    }
    
    redirectTo = (e,buttonType) =>{
        if(buttonType=='affiliate') {
            this.props.history.push(LOGIN_ROUTE_AFFILIATE);
        }
        else if(buttonType=='client') {
            this.props.history.push(LOGIN_ROUTE_CLIENT);
        }
        else if(buttonType=='ios') {
            window.location.href = "https://testflight.apple.com/join/XrneHInM";
        }
        else if(buttonType=='android') {
            window.location.href = "https://drive.google.com/file/d/1cQXUybc4fKLw5yCxS8HvfF6lUi8k2kj_/view?usp=sharing";
        }
    }

    render(){
        
        return(
                <React.Fragment>
                    <img className="logo-width-home" src={LOGO_URL} alt={LBL_APP_NAME} title={LBL_APP_NAME} />
                    <div className="container home-box">

                        <div className="home-row home-bottom-margin10">
                            <div className="home-box-app loginAffiliateButton-new " onClick={(e) => this.redirectTo(e, 'affiliate')}>
                                <div className="home-icon-div">
                                    <img src={require('../'+URL_IMG+'home-affiliate.png')} className="home-icon" alt={LBL_LOGIN_AFFILIATE} title={LBL_LOGIN_AFFILIATE} />  
                                </div> 
                                <span className="home-icon-label">{LBL_LOGIN_AFFILIATE}</span>
                            </div> 

                            <div className="home-box-app loginClientButton " onClick={(e) => this.redirectTo(e, 'client')}>
                                <div className="home-icon-div">
                                    <img src={require('../'+URL_IMG+'home-client.png')} className="home-icon"  alt={LBL_LOGIN_CLIENT} title={LBL_LOGIN_CLIENT} />
                                </div> 
                                <span className="home-icon-label">{LBL_LOGIN_CLIENT}</span>
                            </div>
                        </div>

                        <div className="row col-12"> </div>

                        <div className="home-row home-bottom-margin10">
                            <div className="home-box-app homeMobileAppButton" onClick={(e) => this.redirectTo(e, 'ios')}>
                                <div className="home-icon-div">
                                    <img src={require('../'+URL_IMG+'apple.png')} className="home-icon" alt={LBL_IOS_APP_FOR_STAFF} title={LBL_IOS_APP_FOR_STAFF}  />
                                </div> 
                                <span className="home-icon-label">{LBL_IOS_APP_FOR_STAFF}</span>
                            </div> 
                            
                            <div className="home-box-app homeMobileAppButton" onClick={(e) => this.redirectTo(e, 'android')}>
                                <div className="home-icon-div">
                                    <img src={require('../'+URL_IMG+'android.png')} className="home-icon"  alt={LBL_ANDROID_APP_FOR_STAFF} title={LBL_ANDROID_APP_FOR_STAFF} />
                                </div> 
                                <span className="home-icon-label">{LBL_ANDROID_APP_FOR_STAFF}</span>
                            </div>
                        </div>

                        <div className="row col-12"> </div>
                    </div>
                    
                    <div style={{marginTop:'15px'}}>
                        <FooterComponent />    
                    </div>
                                    
            </React.Fragment>
        )
    }
}

export default LoginView;